import { DefaultState } from 'store/types';
import { Filters } from 'store/types';

export const GET_LODGING_REQUESTS_DATA_REQUEST = 'GET_LODGING_REQUESTS_DATA_REQUEST';
export const GET_LODGING_REQUESTS_DATA_SUCCESS = 'GET_LODGING_REQUESTS_DATA_SUCCESS';
export const GET_LODGING_REQUESTS_DATA_FAILURE = 'GET_LODGING_REQUESTS_DATA_FAILURE';

export interface GetLodgingRequestsParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  };
  sorting: {
    id: string;
    order: string;
  };
  columns: string[];
};

export interface GetLodgingRequestsRow {
  id?: string;
  notesCount?: number;
  userFriendlyId?: number;
  requestDate?: Date;
  address?: string;
  guestType?: string;
  guestTypeName?: string;
  guestId?: string;
  guestName?: string;
  roommatesCount?: number;
  bookingUserFriendlyId?: number;
  requestedStartDate?: string;
  requestedEndDate?: string;
  submitedBy?: string;
  status?: string;
  storeNumber?: string;
  corporateClientName?: string;
  locationId?: string;
  startTimeOfJob?: string;
  distance?: number;
  reservationId?: string;
  clcRequestNumber?: string;
  nights?: number;
  costPerson?: string;
  totalCost?: string;
  lodgingOptionName?: string;
  lodgingOptionAddress?: string;
  isFlagged?: boolean;
};

export interface GetLodgingRequestsData {
  rows: GetLodgingRequestsRow[];
  totalCount: number;
}

export type GetLodgingRequestsState = DefaultState & {
  contents?: GetLodgingRequestsData;
};

interface ReadGetLodgingRequestsDataRequest {
  type: typeof GET_LODGING_REQUESTS_DATA_REQUEST;
};

interface ReadGetLodgingRequestsDataSuccess {
  type: typeof GET_LODGING_REQUESTS_DATA_SUCCESS,
  contents: GetLodgingRequestsData;
}

interface ReadGetLodgingRequestsDataFailure {
  type: typeof GET_LODGING_REQUESTS_DATA_FAILURE;
}

export type GetLodgingRequestsActionTypes = ReadGetLodgingRequestsDataRequest | ReadGetLodgingRequestsDataSuccess | ReadGetLodgingRequestsDataFailure;